<template>
  <div class="q_mar_b100px q_pad_lr15px">

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_mar_t15px q_act_list" @click="goToActivdea(item.id)" :key="item.id" v-for="item in list">
          <van-image fit="cover" :src="convertImg(item.banner)"/>
          <div class="q_text_m q_bold q_moit1 q_mar_t10px" v-text="item.name">“以爱之名 携手同行”助残日志愿服务活动</div>
          <div class="q_text_s q_color_gray q_moit2 q_mar_t5px q_justify" v-text="item.description">
            活动简介活动简介活动简介活动简介活动简介活动简介活动简介活动简介活动简介
          </div>
          <span class="q_text_s q_color_gray q_mar_t15px q_inlineblock"
                v-text="'活动时间:'+parseTime(item.activityStartTime)+' 到 '+parseTime(item.activityEndTime)">2022-04-18 08:00-17:00</span>
          <van-button round type="primary" size="small" color="#FF5733" class="q_flo_right q_mar_t5px"
                      v-if="item.activityEndTime>now">
            立即参与
          </van-button>
          <van-button round type="primary" size="small" color="#FF5733" class="q_flo_right q_mar_t5px" :disabled="true"
                      v-if="item.activityEndTime<now">活动结束
          </van-button>
          <div class="q_clear"></div>
        </div>
      </van-list>

    </van-pull-refresh>

    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>

  </div>
</template>

<script>
import {listActivity} from "@/api/activity";
import {parseTime, wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Activity',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      loading: false,
      finished: false,
      list: [],
      refreshing: false,
      pageParam: {
        pageNum: 0,
        pageSize: 10,
      },
      now: Date.parse(new Date()) / 1000
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 10,
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询活动信息列表
      listActivity(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        for (let i = 0; i < res.rows.length; i++) {
          let item = res.rows[i]
          // 转换时间戳
          item.activityStartTime = Date.parse(new Date(res.rows[i].activityStartTime)) / 1000
          item.activityEndTime = Date.parse(new Date(res.rows[i].activityEndTime)) / 1000

          this.list.push(item);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).then(() => {
        this.$modal.closeLoading()
      })
    },
    goToActivdea(id) {
      this.$router.push({
        path: '/activity/Activdea', query: {id: id}
      });
    },
    formatDate(date) {
      return new Date(date)
    },
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}')
    },
  }
}
</script>
<style scoped="scoped">
.q_act_list >>> .van-image {
  width: 100%;
}

.q_act_list >>> .van-image__img {
  height: 194px;
  border-radius: 5px;
}

.q_act_list >>> .van-button {
  letter-spacing: 1px;
  padding: 0 12px;
}
</style>
